import axios from "axios";
import { ENVIROMENT } from "commons/utils/enviroment";
import cookie from "js-cookie";
import i18n from "i18next"; // 👈 Thêm dòng này

const environment = ENVIROMENT.API;

const instance = axios.create({
  timeout: 25000,
  baseURL: environment,
  headers: {
    "content-type": "application/json",
  },
});

const request = async ({ ...options }) => {
  const onSuccess = async (response) => {
    return response.data;
  };

  const onError = (error) => {
    console.log("error : ", error);
    if (error.response && error.response.data) {
      return error.response.data;
    }
    return {
      message: error.message || "Unknown error occurred",
      status: error.response?.status || 500,
    };
  };

  const token = cookie.get("token");
  if (token) {
    instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  // 🟩 Thêm header accept-language dựa vào ngôn ngữ hiện tại của i18n
  const language = i18n.language || "vi";
  let acceptLanguage = "en-US,vi;q=0.9,vi-VN;q=0.8,en;q=0.7";
  if (language === "vi") {
    acceptLanguage = "vi-VN,vi;q=0.9,en-US;q=0.8,en;q=0.7";
  }
  instance.defaults.headers.common["accept-language"] = acceptLanguage;

  instance.interceptors.response.use((response) => {
    return response;
  });

  return instance(options).then(onSuccess).catch(onError);
};

const get = async (endPoint, params) => {
  return await request({
    method: "GET",
    url: endPoint,
    params,
  });
};

const post = async (endPoint, data, config) => {
  return await request({
    method: "POST",
    url: endPoint,
    data,
    headers: config,
  });
};

const put = async (endPoint, data) => {
  return await request({
    method: "PUT",
    url: endPoint,
    data,
  });
};

const _delete = async (endPoint, params) => {
  return await request({
    method: "DELETE",
    url: endPoint,
    params,
  });
};

export const httpService = {
  get,
  post,
  put,
  delete: _delete,
};
